exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-overlay[data-v-09eac16a]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:1000}.modal-content[data-v-09eac16a]{background:#fff;padding:2rem;box-shadow:0 2px 8px rgba(0,0,0,.2);min-width:300px;border-radius:0;position:relative;max-height:80dvh;overflow:auto}button[data-v-09eac16a]{position:absolute;top:10px;right:10px}", ""]);

// exports
